export const formatNumber = (value: string) => +value;

export const recoverNumber = (value: number) => `${value}`;
